import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ViewCell} from 'ng2-smart-table';
import {ApiService} from '../../../../@core/service/api.service';
import { NrkWindowComponent } from '../../../erp/shared/nrk-window/nrk-window.component';
import { ProjectModel } from '../../../../@models';

@Component({
  selector: 'ngx-form-list-project-renderer',
  template: `
    <a [routerLink]="[]" (click)="openProject(rowData)">{{renderValue}}
    <nrk-window #projectWindow>
      <nrk-header>Project</nrk-header>
      <nrk-content>
        <div style="width:70rem;padding:2rem">
          <ngx-project-edit [project]="editProject" (saved)="onWindowSaved()" (cancelled)="onWindowCancelled()"></ngx-project-edit>
        </div>
      </nrk-content>
    </nrk-window>
  `,
})
export class FormListProjectRendererComponent implements ViewCell, OnInit {
  renderValue: string;
  editProject: ProjectModel;

  @Input() value: any;
  @Input() rowData: any;

  @ViewChild('projectWindow') projectWindow: NrkWindowComponent;

  constructor(private api: ApiService) {

  }


  ngOnInit() {
    const prj = this.api.getProject(this.value);
    if (prj != null)
      this.renderValue = prj.name;
    else
      this.renderValue = 'error';
    this.editProject = prj;
  }

  openProject(rowData: any) {
    if (!this.editProject) {
      const prj = this.api.getProject(this.value ?? rowData.project);
      if (prj) this.editProject = prj;
    }
    this.projectWindow.open(rowData);
  }

  onWindowSaved(): void {
    this.projectWindow.close();
  }

  onWindowCancelled(): void {
    this.projectWindow.close();
  }

}
